import React from 'react';
import SubjectPage from '../../Subjects/SubjectPage';

function MindMap() {

    const pageTitleText = "JEE Mind Map ";

  return (
    <>
    
      <SubjectPage 
        name={pageTitleText} 
        link="mindmap" 
      />

    </>
  );
}

export default MindMap;